import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-wrapper container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "logo-wrapper__logo",
    translate: "no"
  }, "Wavelovers")
], -1)
const _hoisted_4 = { class: "menu-wrapper" }
const _hoisted_5 = { class: "navigation" }
const _hoisted_6 = { class: "navigation__item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_8 = { class: "navigation__item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("FAQ")
const _hoisted_10 = { class: "navigation__item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_12 = { class: "navigation__item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Donate")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("nav", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, { to: "/faq" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, { to: "/donate" }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}